<script lang="ts">
  import type { AuraView } from '../../game/hud.svelte';

  let { aura }: { aura: AuraView } = $props();

  const remaining = $derived(
    aura.remaining <= 0
      ? ''
      : aura.remaining >= 60
        ? `${Math.ceil(aura.remaining / 60)} min remaining`
        : `${Math.ceil(aura.remaining)} sec remaining`,
  );
</script>

<div class="tooltip">
  <div class="row">
    <span class="name" class:harmful={aura.harmful}>{aura.name}</span>
    {#if aura.dispel}<span class="dispel">{aura.dispel}</span>{/if}
  </div>
  <div class="desc">{aura.description}</div>
  {#if aura.absorb > 0}<div>{aura.absorb} damage left to absorb</div>{/if}
  {#if remaining}<div class="time">{remaining}</div>{/if}
  {#if aura.cancelable}<div class="hint">Click to cancel</div>{/if}
</div>

<style>
  .tooltip {
    width: 260px;
    padding: 10px 12px;
    background: var(--panel-solid);
    border: 1px solid var(--border);
    border-radius: 6px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.6);
    font-size: 14px;
    line-height: 1.35;
    color: #fff;
  }
  .row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
  }
  .name {
    font-size: 16px;
    font-weight: bold;
  }
  .name.harmful {
    color: var(--enemy);
  }
  .dispel {
    color: #6aa8ff;
    text-transform: capitalize;
  }
  .desc {
    color: var(--gold);
  }
  .time {
    color: #ffd34a;
  }
  .hint {
    margin-top: 4px;
    color: var(--muted);
  }
</style>
